import React, { Component } from 'react';
import { Field } from 'redux-form';
import { set } from 'lodash';
import { Icon } from 'semantic-ui-react';

import ReactTable from 'Common/ReactTableWrapper';
import { InputField } from 'Common/SemanticWrapper';
import { InputMode } from 'Common/FormEnum';
import { formatToCash } from 'Common/FormHelper';

class BaseRatesGrid extends Component {
  constructor(props) {
    super(props);

    this.Columns = [
      {
        Header: 'Month',
        accessor: 'Month',
        style: { fontWeight: 'bold' },
      },
      {
        Header: 'Free',
        accessor: 'FreeRate',
        Cell: this.PercentageInput,
        width: 175,
      },
      {
        Header: 'Reduced',
        accessor: 'ReducedRate',
        Cell: this.PercentageInput,
        width: 175,
      },
      {
        Header: 'Paid',
        accessor: 'PaidRate',
        Cell: this.PercentageInput,
        width: 175,
      },
      {
        Header: 'Total',
        accessor: 'Total',
        width: 250,
        Cell: cellInfo => {
          const { isBreakfast, siteId, loading } = this.props;
          const header = cellInfo.column.Header;
          return (
            <Field
              label={false}
              icon={<Icon name="percent" />}
              hideError
              component={InputField}
              name={`${cellInfo.original.Month}${header}${
                isBreakfast ? 'Breakfast' : 'Lunch'
              }`}
              disabled={siteId === null || loading}
              readOnly
            />
          );
        },
      },
    ];
  }

  PercentageInput = cellInfo => {
    const header = cellInfo.column.Header;
    const { isBreakfast, siteId, loading } = this.props;
    const FieldName = `${cellInfo.original.Month}${header}${
      isBreakfast ? 'Breakfast' : 'Lunch'
    }`;

    return (
      <Field
        label={false}
        icon={<Icon name="percent" />}
        component={InputField}
        name={FieldName}
        mode={InputMode.Decimal}
        hideError
        disabled={siteId === null || loading}
        numericSize={[5, 2]}
        formatOnBlur={formatToCash}
        allowNegative={false}
        onBlur={(e, data) => {
          this.calculateTotalAndUpdateGridData(data, cellInfo.original, header);
        }}
      />
    );
  };

  calculateTotalAndUpdateGridData = (data, rowInfo, header) => {
    const {
      isBreakfast,
      gridData,
      updateTotalField,
      updateGridData,
    } = this.props;

    const cellData = data !== '' ? parseFloat(data) : 0;

    const foundRow = gridData.find(row => row.Month === rowInfo.Month);
    const index = gridData.indexOf(foundRow);

    set(gridData[index], `${header}`, cellData);

    const total =
      (parseFloat(gridData[index].Free) || 0) +
      (parseFloat(gridData[index].Reduced) || 0) +
      (parseFloat(gridData[index].Paid) || 0);

    set(gridData[index], 'Total', total);

    updateGridData(gridData);

    updateTotalField(
      `${rowInfo.Month}Total${isBreakfast ? 'Breakfast' : 'Lunch'}`,
      formatToCash(total)
    );
  };

  commonProps = () => {
    return {};
  };

  render() {
    return (
      <ReactTable
        columns={this.Columns}
        data={this.props.gridData || []}
        getTfootProps={() => ({ style: { fontWeight: 'bold' } })}
        showPagination={false}
        menu={false}
        filterable={false}
        sortable={false}
        minRows={0}
        resizable={false}
      />
    );
  }
}

export { BaseRatesGrid };



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/component/BaseRatesGrid.js